const ctas = document.querySelector('.c-ctas')

if (ctas) {
    const items = ctas.querySelectorAll('.item')
    const popups = ctas.querySelectorAll('.popup')

    if (items.length > 0) {
        for (const item of items) {
            item.addEventListener('click', (e) => {
                const id = e.target.dataset.id
                for (const item of items) {
                    item.classList.remove('active')
                }
                for (const item of popups) {
                    item.classList.remove('active')
                }
                if (id !== ctas.dataset.active) {
                    ctas.querySelector(`.item[data-id="${id}"]`)?.classList.add(
                        'active'
                    )
                    ctas.querySelector(
                        `.popup[data-id="${id}"]`
                    )?.classList.add('active')
                    ctas.dataset.active = id
                } else {
                    ctas.dataset.active = ''
                }
            })
        }
    }
}
